import { useCallback } from "react"
import { useSelector } from "react-redux"

const useClientPermissionsAccess = () => {
    const {
        current_role_permissions_state,
    } = useSelector(state => ({
        current_role_permissions_state: state.Role.current_role_permissions_state,
    }))

    const getActivePermissions = useCallback((permission_keys) => {
        return (current_role_permissions_state || [])
                 .filter(perm => perm.isActive)
                 .map(perm => permission_keys.includes(perm.ui_key))
    }, [current_role_permissions_state])

    return getActivePermissions;
}

export default useClientPermissionsAccess;
